/* Free gift wrap on every order: one per cart, only with another product, not removable.
   The free gift wrap runs only until window.GWAuto.giftWrapEnd; after that it is optional again.
   Also a free gift coin when the rest of the cart, after our coupon discounts (window.GWAuto.coinDiscount), is at or above window.GWAuto.coinThreshold (paise).
   Starts at window.GWAuto.start. Add ?gwa_test=1 to the URL to try it before then. */
(function () {
  var cfg = window.GWAuto;
  if (!cfg || !cfg.variantId) return;
  if (window.Shopify && window.Shopify.designMode) return;

  var VID = Number(cfg.variantId);
  var forced = /[?&]gwa_test=1/.test(location.search);
  function active() { return forced || Date.now() >= cfg.start; }

  var GW_END = Number(cfg.giftWrapEnd) || 0;
  var forcedEnded = /[?&]gwa_end=1/.test(location.search);
  /* The free gift wrap promotion runs from the start time until giftWrapEnd; after that the gift wrap is optional again */
  function gwActive() { return active() && !forcedEnded && (!GW_END || Date.now() < GW_END); }

  var html = document.documentElement;
  var origFetch = window.fetch;
  var busy = false, pending = false;

  function turnOn() { if (gwActive()) html.classList.add('gwa-on'); }
  function turnOff() { html.classList.remove('gwa-on'); }
  if (active()) {
    turnOn();
  } else {
    var wait = cfg.start - Date.now();
    if (wait > 0 && wait < 86400000) {
      setTimeout(function () { turnOn(); sync(); }, wait + 500);
    }
  }
  // flip the checkboxes and remove links back when the gift wrap promotion ends, even on an open page
  if (GW_END && !forcedEnded) {
    var untilEnd = GW_END - Date.now();
    if (untilEnd > 0 && untilEnd < 86400000) {
      setTimeout(function () { turnOff(); sync(); }, untilEnd + 500);
    }
  }

  function post(url, body) {
    return origFetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    });
  }

  function readCart() {
    return post('/cart/update.js', { updates: {} }).then(function (r) { return r.json(); });
  }

  function refreshUI() {
    if (/^\/cart\/?$/.test(location.pathname)) {
      location.reload();
    } else {
      document.dispatchEvent(new CustomEvent('cart:build'));
    }
  }

  var COIN = Number(cfg.coinVariantId) || 0;
  var THRESHOLD = Number(cfg.coinThreshold) || 0;
  var DISC = cfg.coinDiscount || null;

  /* Product tags (to know which lines get no discount / the sale discount), fetched once per product */
  var tagCache = {};
  function loadTags(cart) {
    if (!DISC) return Promise.resolve(cart);
    var todo = [];
    cart.items.forEach(function (i) {
      if (i.handle && !tagCache[i.handle] && todo.indexOf(i.handle) === -1) todo.push(i.handle);
    });
    return Promise.all(todo.map(function (h) {
      return origFetch('/products/' + h + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : { tags: [] }; })
        .then(function (p) { tagCache[h] = p.tags || []; })
        .catch(function () { tagCache[h] = []; });
    })).then(function () { return cart; });
  }

  /* What the other items will cost after our coupon (the coin needs this to be at or above the threshold).
     If a discount code is already applied to the cart, use the cart's own discounted amount instead. */
  function amountAfterDiscount(lines, cart) {
    var amt = function (l) { return l.final_line_price != null ? l.final_line_price : l.line_price; };
    var gross = 0;
    lines.forEach(function (l) { gross += amt(l); });
    if (!DISC) return gross;
    var applied = (cart.cart_level_discount_applications || []).reduce(function (a, d) { return a + (d.total_allocated_amount || 0); }, 0);
    if (applied > 0) return gross - applied;
    var rate = gross >= DISC.t2Min * 100 ? DISC.t2 : (gross >= DISC.t1Min * 100 ? DISC.t1 : 0);
    var after = 0;
    lines.forEach(function (l) {
      var tags = tagCache[l.handle] || [];
      var noDisc = (DISC.noDiscountTags || []).some(function (t) { return tags.indexOf(t) > -1; });
      var sale = DISC.saleTag && tags.indexOf(DISC.saleTag) > -1;
      var r = noDisc ? 0 : (sale ? DISC.sale : rate);
      after += amt(l) * (100 - r) / 100;
    });
    return Math.round(after);
  }

  /* Works out what must change so the cart holds exactly one free gift wrap (only with other products) and exactly
     one free coin (only above the threshold). A free item can sit on several cart lines (e.g. added with and without
     the "Free gift" label), so every line of it is looked at, extra lines are removed and the kept line is set to 1. */
  var endCleanupDone = false;
  function plan(cart) {
    var gwLines = [], coinLines = [], otherLines = [], others = 0, value = 0, ops = [];
    cart.items.forEach(function (i) {
      var vid = Number(i.variant_id);
      if (vid === VID) gwLines.push(i);
      else if (COIN && vid === COIN) coinLines.push(i);
      else { others += i.quantity; otherLines.push(i); }
    });
    value = amountAfterDiscount(otherLines, cart);
    function remove(lines) {
      lines.forEach(function (l) { ops.push(function () { return post('/cart/change.js', { id: l.key, quantity: 0 }); }); });
    }
    function setOne(line) {
      if (line.quantity !== 1) ops.push(function () { return post('/cart/change.js', { id: line.key, quantity: 1 }); });
    }

    // free gift wrap: one, and only with another product (only while the promotion runs)
    if (gwActive()) {
      if (others > 0) {
        if (!gwLines.length) ops.push(function () { return post('/cart/add.js', { items: [{ id: VID, quantity: 1 }] }); });
        else { setOne(gwLines[0]); remove(gwLines.slice(1)); }
      } else {
        remove(gwLines);
      }
    } else if (!endCleanupDone) {
      // first visit after the promotion: a gift wrap still in the cart was added automatically earlier, so take it out once
      endCleanupDone = true;
      try {
        if (!localStorage.getItem('gwa-end-clean')) {
          localStorage.setItem('gwa-end-clean', '1');
          remove(gwLines);
        }
      } catch (e) {}
    }

    // free coin: one, labelled "Free gift", only above the threshold
    if (COIN && THRESHOLD) {
      var eligible = others > 0 && value >= THRESHOLD;
      if (eligible) {
        var keep = null;
        coinLines.forEach(function (l) { if (!keep && l.properties && l.properties['Free gift']) keep = l; });
        if (!keep) {
          remove(coinLines);
          ops.push(function () { return post('/cart/add.js', { items: [{ id: COIN, quantity: 1, properties: { 'Free gift': 'Yes' } }] }); });
        } else {
          setOne(keep);
          remove(coinLines.filter(function (l) { return l !== keep; }));
        }
      } else {
        remove(coinLines);
      }
    }
    return ops;
  }

  function run(ops) {
    return ops.reduce(function (chain, op) { return chain.then(op); }, Promise.resolve());
  }

  /* Second pass after changes, in case anything still differs (a stale read, two quick changes) */
  function tidy() {
    return readCart().then(loadTags).then(function (cart) { return run(plan(cart)); }).catch(function () {});
  }

  function sync(skipUI) {
    if (!active()) return Promise.resolve(false);
    if (busy) { pending = true; return Promise.resolve(false); }
    busy = true;
    return readCart()
      .then(loadTags)
      .then(function (cart) {
        var ops = plan(cart);
        return run(ops).then(function () { return ops.length > 0 ? tidy().then(function () { return true; }) : false; });
      })
      .catch(function () { return false; })
      .then(function (changed) {
        busy = false;
        if (changed && !skipUI) refreshUI();
        if (pending) { pending = false; return sync(skipUI); }
        return changed;
      });
  }

  var CART_URL = /\/cart\/(add|change|update|clear)/;

  /* Re-check after the theme or any script changes the cart */
  window.fetch = function (input) {
    var p = origFetch.apply(this, arguments);
    try {
      var u = typeof input === 'string' ? input : (input && input.url) || '';
      if (CART_URL.test(u)) p.then(function () { setTimeout(sync, 200); }, function () {});
    } catch (e) {}
    return p;
  };
  var xhrOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__gwaCart = CART_URL.test(String(url));
    return xhrOpen.apply(this, arguments);
  };
  var xhrSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    if (this.__gwaCart) this.addEventListener('loadend', function () { setTimeout(sync, 200); });
    return xhrSend.apply(this, arguments);
  };

  /* Make sure it is in the cart right before checkout */
  document.addEventListener('click', function (e) {
    var el = e.target.closest && e.target.closest('[name="checkout"], a[href*="/checkout"]');
    if (!el || !active() || el.getAttribute('data-gwa-ok')) return;
    e.preventDefault();
    e.stopPropagation();
    sync(true).then(function () {
      el.setAttribute('data-gwa-ok', '1');
      el.click();
    });
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { sync(); });
  else sync();
})();
